<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div slot="header">
          주문 정보
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">주문 처리</th>
                      <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">
                        <b-button size="sm" class="mx-1" variant="outline-primary" v-on:click="orderPassbookConFirm()" v-show="orderDataItems.status == 'ORDER_STATUS_TYPE_1'" style="border-radius:5px; cursor:pointer; font-size:15px"><h5 style="margin-bottom:0px">입금확인</h5></b-button>
                        <b-button size="sm" class="mx-1" variant="outline-danger" v-on:click="orderCancelConFirm()" v-show="orderDataItems.status == 'ORDER_STATUS_TYPE_1' || orderDataItems.status == 'ORDER_STATUS_TYPE_3'" style="border-radius:5px; cursor:pointer; font-size:15px"><h5 style="margin-bottom:0px">주문취소</h5></b-button>
                        <span class="badge badge-success" style="font-size:15px; color:#ffffff" v-show="orderDataItems.status == 'ORDER_STATUS_TYPE_2'">결제대기</span>
                        <span class="badge badge-dark" style="font-size:15px; color:#ffffff" v-show="orderDataItems.status == 'ORDER_STATUS_TYPE_4'">주문취소일 : {{orderDataItems.cancel_date}}</span>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">주문번호</th>
                      <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDataItems.order_code}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">주문상태</th>
                      <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">
                        <span :class="'badge badge-'+(orderDataItems.status == 'ORDER_STATUS_TYPE_1' ? 'primary' : orderDataItems.status == 'ORDER_STATUS_TYPE_2' ? 'success' : orderDataItems.status == 'ORDER_STATUS_TYPE_3' ? 'danger' : orderDataItems.status == 'ORDER_STATUS_TYPE_4' ? 'dark' : orderDataItems.status == 'ORDER_STATUS_TYPE_5' ? 'secondary' : '')" style="font-size:15px; color:#ffffff">
                          {{orderDataItems.status_name}}
                        </span>
                      </td>
                  </tr>
                  <!-- v-for="(optItem, optIndex) in orderDetailOptList" -->
                  <template v-if="orderDetailOptList.length > 1">
                    <template v-for="item, index in orderDetailOptList">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">상품코드 #{{index+1}}</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{item.op_code}}</td>
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">소비자가</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">₩ {{Number(item.opt_price).toLocaleString()}}</td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">상품명 #{{index+1}}</th>
                        <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">{{item.op_name}}</td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">옵션명 #{{index+1}}</th>
                        <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">[{{item.opt_code}}] {{item.opt_name}}</td>
                      </tr>
                    </template>
                  </template>

                  <template v-else>
                    <template v-for="item, index in orderDetailOptList">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">상품코드</th>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{item.op_code}}</td>
                          <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">소비자가</th>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:left">₩ {{Number(item.opt_price).toLocaleString()}}</td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">상품명</th>
                          <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">{{item.op_name}}</td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">옵션명</th>
                          <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">[{{item.opt_code}}] {{item.opt_name}}</td>
                      </tr>
                    </template>
                  </template>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">주문일</th>
                      <td class="" colspan="3" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDataItems.order_date}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <div slot="header">
          주문자 정보
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">주문자명</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{ordererData.order_name}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">이메일</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{ordererData.email}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">휴대폰번호</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{ordererData.mobile}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">회사(기업)정보</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{ordererData.industry_name}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">회사(기관)명</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{ordererData.company}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <div slot="header">
          결제 정보
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <tbody class="">
                  <template v-if="orderDetailOptList.length > 1">
                    <template v-for="item, index in orderDetailOptList">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">결제방식 #{{index+1}}</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                          {{orderDataItems.pay_type == 'admintype' ? '관리자 임의 지정' : orderDataItems.pay_type == 'eventtype' ? '이벤트 지급' : orderDataItems.pay_type_name}}
                        </td>
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">소비자가</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">₩ {{Number(item.opt_price).toLocaleString()}}</td>
                      </tr>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="item, index in orderDetailOptList">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">결제방식</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                          {{orderDataItems.pay_type == 'admintype' ? '관리자 임의 지정' : orderDataItems.pay_type == 'eventtype' ? '이벤트 지급' : orderDataItems.pay_type_name}}
                        </td>
                        <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">소비자가</th>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">₩ {{Number(item.opt_price).toLocaleString()}}</td>
                      </tr>
                    </template>
                  </template>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">결제금액</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">￦ {{Number(orderDataItems.amount).toLocaleString()}}</td>
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">수량</th>
<!--                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDetailOptList[0].order_opt_cnt == 0 ? '1' : orderDetailOptList[0].order_opt_cnt}}</td>-->
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDetailOptList.length}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1">쿠폰정보</th>
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDataItems.coupon_code == '' || orderDataItems.coupon_code != null ? '쿠폰 사용내역 없음' : '['+orderDataItems.coupon_code+'] '+orderDataItems.coupon_name+' ('+orderDataItems.coupon_pub_id+')'}}</td>
                      <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">할인금액</th>
                      <!-- <td class="" style="border-right:1px solid #a4b7c1; text-align:left">- ₩ {{Number(orderDataItems.dc_price).toLocaleString()}}</td> -->
                      <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDataItems.dc_price != null && orderDataItems.dc_price != 0 ? '- ₩ '+Number(orderDataItems.dc_price).toLocaleString() : '할인정보 없음'}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <div slot="header">
          계산서 발행 정보
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                  <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">구분</th>
                  <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                    <b-form-radio-group id="cashReceiptsCode" name="cashReceiptsCode">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="cashReceiptsCodeY" name="cashReceiptsCode" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_code" value="CASH_RECEIPT_TYPE_2">
                        <label class="custom-control-label" for="cashReceiptsCodeY">개인/법인 사업자</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="cashReceiptsCodeN" name="cashReceiptsCode" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_code" value="CASH_RECEIPT_TYPE_1">
                        <label class="custom-control-label" for="cashReceiptsCodeN">소비자 (사업자등록번호 없음)</label>
                      </div>
                    </b-form-radio-group>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                  <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">구매 증빙</th>
                  <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                    <b-form-radio-group id="basicCustomTaxyn" name="taxyn">
                      <div class="custom-control custom-radio custom-control-inline" v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_2'">
                        <input type="radio" id="taxY" name="taxyn" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_yn" value="N">
                        <label class="custom-control-label" for="taxY">세금계산서</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline" v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_2'">
                        <input type="radio" id="taxN" name="taxyn" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_yn" value="Y">
                        <label class="custom-control-label" for="taxN">현금영수증 (지출증빙용)</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline" v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_1'">
                        <input type="radio" id="cashReceiptsYnY" name="cashReceiptsYn" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_yn" value="Y">
                        <label class="custom-control-label" for="taxN">현금영수증 (소득공제용)</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline"v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_1'">
                        <input type="radio" id="cashReceiptsYnN" name="cashReceiptsYn" disabled class="custom-control-input" v-model="orderDataItems.cash_receipts_yn" value="N">
                        <label class="custom-control-label" for="taxN">증빙 신청 안함</label>
                      </div>
                    </b-form-radio-group>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_1'">
                  <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">휴대폰번호</th>
                  <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                    {{orderDataItems.tax_tel != '' && orderDataItems.tax_tel != null ? orderDataItems.tax_tel : '없음'}}
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-if="orderDataItems.cash_receipts_code == 'CASH_RECEIPT_TYPE_2'">
                  <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">사업자등록증</th>
                  <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                    {{orderDataItems.bl_file_originalname != '' && orderDataItems.bl_file_originalname != null ? orderDataItems.bl_file_originalname : '등록된 파일 없음'}}
                    <b-button variant="info" v-if="orderDataItems.bl_file_originalname != '' && orderDataItems.bl_file_originalname != null" style="color:#ffffff; margin-left:12px; border-radius:5px; cursor:pointer; width:150px; border:1px solid #187c9f; font-size:15px" v-on:click="blFileDownload()"><i class="fa fa-file-text-o"></i> 파일 다운로드</h5></b-button>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                  <th class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; width:200px">계산서/영수증 수신 이메일</th>
                  <td class="" style="border-right:1px solid #a4b7c1; text-align:left">{{orderDataItems.invoice_mail != '' && orderDataItems.invoice_mail != null ? orderDataItems.invoice_mail : '없음'}}</td>
                </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'
import alasql from 'alasql';

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      queryParams: {},
      orderDataItems: {},
      orderDetailReportList: [],
      orderDetailOptList: [],
      order_p_code: '',
      ordererData: {},
      orderUserDelivery: {},
      opttapCheck: true,
      pkgtapCheck: false,
      ordercode: '',
      drDeleteRows: [],
      reportDataItems: {
        attachmentFileItems:[],
        previewFileItems:[],
        listThumbnailFile:[],
        categoryitems:[],
      },
      optList: [],
      pkgList: [],
      optiontap:'normaltap',
      tap_option_type:'POT_1',
    }
  },
  watch: {},
  mounted: function() {
    // ### 주문내역 정보 불러오기 ###
    // 주문내역을 DB테이블에서 조회
    // 최초작성 : 2016.08.27
    // 파라미터 : ordercode
    //  - ordercode
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.08.27  황경현   최초작성
    // *************************
    this.orderInfoInit();
  },
  methods: {
    orderInfoInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.ordercode = self.$session.get('param_order_code');
      if(self.ordercode != ''){
        self.$http.get('/api/select/drOrderData?access_token=' + token + '&ordercode=' + self.ordercode + '&ordertype=RP')
        .then((result) => {
          console.log(result.data);
          self.orderDataItems = result.data;
          self.orderDetailReportList = self.orderDataItems.orderDetailReport;
          self.orderDetailOptList = self.orderDataItems.orderDetailOptList;
          self.orderUserDelivery = self.orderDataItems.orderUserDelivery;
          self.ordererData = self.orderDataItems.ordererList;
          self.orderDetailOptList.forEach(function (el, idx, arr){
            if(idx == 0){
              self.order_p_code = el.op_code;
            }
          });
        })
      }
    },
    orderPassbookConFirm() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.order_code = self.ordercode;
      self.queryParams.coupon_pub_id = self.orderDataItems.coupon_pub_id;
      self.queryParams.coupon_code = self.orderDataItems.coupon_code;
      self.queryParams.user_id = self.orderDataItems.user_id;
      self.queryParams.order_type = "RP";
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObj', param);

      swal.fire({
        title: '입금확인 처리를 하시겠습니까?',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        // html: "입금확인 처리를 하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          self.$http.post('/api/update/orderPassbookConFirm?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '입금확인이 완료 되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  self.orderInfoInit();
              });
          })
        }else{
        }
      })
    },
    orderCancelConFirm(){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.order_code = self.ordercode;
      self.queryParams.coupon_pub_id = self.orderDataItems.coupon_pub_id;
      self.queryParams.coupon_code = self.orderDataItems.coupon_code;
      self.queryParams.user_id = self.orderDataItems.user_id;
      self.queryParams.order_type = "RP";
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObj', param);

      swal.fire({
        title: '보고서 주문취소!',
        html: "<b>주문취소시 해당 유저의 보고서 구매내역이 삭제됩니다.</br> 진행 하시겠습니까?</b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          self.$http.post('/api/update/orderCancelConFirm?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '주문건이 취소 되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  self.orderInfoInit();
              });
          })
        }else{
        }
      })
    },
    blFileDownload(){
      var self = this;
      var data = new FormData();
      data.append('ordercode', self.orderDataItems.order_code);
      data.append('userId', self.orderDataItems.user_id);
      self.$http.post('/fileservice/download', data, { responseType: 'blob'})
      .then((result) => {
        var blob = result.data;
        if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
          window.navigator.msSaveOrOpenBlob(blob, self.orderDataItems.bl_file_originalname);
        }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = self.orderDataItems.bl_file_originalname;
            document.body.appendChild(link);//For FireFox <a> tag event
            //not working
            link.click();
        }else{
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = self.orderDataItems.bl_file_originalname;
            link.click();
        }
        // clearInterval(downProgressText);
        // downNum = 0;
        // downIngs = "";
        // $("#downIng").empty();
        // $("#downButton").show();
        // $("#downButtonIng").hide();
        // 다운로드 한다음 실행asdasdasd
        // DB에 다운로드 정보 저장...

      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/order/OrderProductInfo.vue